import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-eca6041e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "login_wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Ciao Camera"
  })
], -1))
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { class: "input_wrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "email", -1))
const _hoisted_7 = { class: "input_wrap last_input" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "password", -1))
const _hoisted_9 = { class: "nav" }

import InputField from '@/components/atoms/InputField'
import IconButton from '@/components/molecules/IconButton'
import PasswordInputFiled from '@/components/molecules/PasswordInputField'
import PasswordReissueDialog from '@/components/organisms/PasswordReissueDialog'
import NotRecommendedDialog from '@/components/pages/Login/components/NotRecommendedDialog'
import SimpleSelectBox from '@/components/atoms/SimpleSelectBox'
import APP from '@/js/const/app'
import { isRecommendedBrowser } from '@/js/utils/util'
import { authErrorMessage } from '@/js/utils/auth'
import { useStore } from 'vuex'
import querystring from 'querystring'
import { computed, onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import axios from 'axios'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props) {

const store = useStore()
const route = useRoute()
const router = useRouter()

const loading = ref<boolean>(false)
const email = ref<string>('')
const password = ref<string>('')
const displayReissueDialogFlag = ref<boolean>(false)
const notRecommendedDialogFlag = ref<boolean>(false)
const selectedLanguage = ref<string>('')
const selectLanguageOption = APP.SELECT_LANGUAGE_OPTIONS
const isValidEmail = ref<boolean>(false)
const isValidPassword = ref<boolean>(false)

onMounted(() => {
  if (!isRecommendedBrowser()) {
    notRecommendedDialogFlag.value = true
  }
})

/**
 * ログイン
 */
const submit = async () => {
  if (loading.value) {
    return
  }
  try {
    loading.value = true
    let appKey = null
    // リダイレクト先 URL から端末認証キーを取得
    const redirectUrl = String(route.query.redirect)
    if (redirectUrl && redirectUrl.indexOf('?') >= 0) {
      appKey = querystring.parse(redirectUrl.split('?')[1]).appKey
    }
    await store.dispatch('auth/login', {
      email: email.value,
      password: password.value,
      appKey: appKey,
    })

    // URLにリダイレクト先が指定されている場合は、指定先に遷移
    if (route.query.redirect) {
      if (String(route.query.redirect).startsWith('/camera')) {
        // 人数カウント) /camera で始まるパスは全体を遷移
        window.location.href = String(route.query.redirect)
      } else {
        await router.push(String(route.query.redirect))
      }
    } else {
      await router.push({ name: 'list', params: { page: 1 } })
    }
  } catch (error: unknown) {
    if (!axios.isAxiosError(error)) throw error
    const message = authErrorMessage(error.response?.data.data.reason)
    ElMessage({
      dangerouslyUseHTMLString: true,
      message: message,
      type: 'error',
    })
  } finally {
    loading.value = false
  }
}

const openReissueDialog = () => {
  displayReissueDialogFlag.value = true
}

const changeLang = (lang: string) => {
  store.commit('app/setLang', lang)
}

const loginDisabled = computed(() => loading.value || !isValidEmail.value || !isValidPassword.value)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("form", {
        onSubmit: _withModifiers(submit, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_unref(InputField), {
            modelValue: email.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            "is-valid": isValidEmail.value,
            "onUpdate:is-valid": _cache[1] || (_cache[1] = ($event: any) => ((isValidEmail).value = $event)),
            type: "text",
            klass: "round_white",
            name: "email",
            "name-as": _ctx.$t('validation.email'),
            rule: "required|email",
            "validate-on": "blur"
          }, null, 8, ["modelValue", "is-valid", "name-as"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_unref(PasswordInputFiled), {
            modelValue: password.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
            "is-valid": isValidPassword.value,
            "onUpdate:is-valid": _cache[3] || (_cache[3] = ($event: any) => ((isValidPassword).value = $event)),
            klass: "round_white",
            name: "password",
            rule: "required",
            "name-as": _ctx.$t('validation.password')
          }, null, 8, ["modelValue", "is-valid", "name-as"])
        ]),
        _createVNode(_unref(IconButton), {
          icon: "arrow_forward",
          "bg-color": "white",
          "use-border": false,
          "use-circle": true,
          disabled: _unref(loginDisabled),
          loading: loading.value,
          type: "submit",
          iconColor: "color-primary"
        }, null, 8, ["disabled", "loading"])
      ], 40, _hoisted_4),
      _createElementVNode("ul", _hoisted_9, [
        _createElementVNode("li", { onClick: openReissueDialog }, _toDisplayString(_ctx.$t('login_nav.lost_password')), 1),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/help",
            class: "li_link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('login_nav.help')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_unref(SimpleSelectBox), {
            modelValue: selectedLanguage.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedLanguage).value = $event)),
            placeholder: "Language",
            size: "medium",
            "bg-color": "no_color",
            onChange: _cache[5] || (_cache[5] = ($event: any) => (changeLang(selectedLanguage.value))),
            options: _unref(selectLanguageOption)
          }, null, 8, ["modelValue", "options"])
        ])
      ])
    ]),
    _createVNode(_unref(PasswordReissueDialog), {
      modelValue: displayReissueDialogFlag.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((displayReissueDialogFlag).value = $event)),
      loginEmail: email.value
    }, null, 8, ["modelValue", "loginEmail"]),
    _createVNode(_unref(NotRecommendedDialog), {
      modelValue: notRecommendedDialogFlag.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((notRecommendedDialogFlag).value = $event))
    }, null, 8, ["modelValue"])
  ]))
}
}

})